import {
    FETCH_MISSION_STATEMENT_CONTENT_SUCCESS,
    FETCH_MISSION_STATEMENT_CONTENT_FAILED,
} from "../actions/actionTypes";

const initialState = {
    isLoading: true,
    isFormProcessing: true,
    content: {},
    error: false,
    news: []
};

export default function (state = initialState, { type, payload }) {
    switch (type) {
        case FETCH_MISSION_STATEMENT_CONTENT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                content: payload
            };
        case FETCH_MISSION_STATEMENT_CONTENT_FAILED:
            return {
                ...state,
                isLoading: false,
                error: payload
            };

        default:
            return state;
    }
}
